import { jsx as _jsx } from "react/jsx-runtime";
import { icons, sizesIcon, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { themeCore } from "../../assets/themes/theme";
import { variantsAvatar } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { GridCheckCircleIcon } from "@mui/x-data-grid";
import logoAffinity from "../../assets/images/logoAffinity.svg";
export var userView = [
    {
        active: false,
        icon: {
            icon: icons.List,
        },
        id: "1",
        name: "List",
    },
    {
        active: true,
        icon: {
            icon: icons.GridView,
        },
        id: "2",
        name: "GridView",
    },
];
export var buttonActionOptions = [
    {
        icons: icons.Menu,
        id: "1",
        name: "Modificar",
    },
];
export var buttonActionOptionsList = [
    {
        disabled: false,
        id: "1",
        name: "Modificar",
        divider: false,
        icon: {
            color: "#006ac6",
            icon: icons.Edit,
            size: sizesIcon.standard,
        },
    },
];
export var optionsSelect = [
    {
        id: "1",
        name: "Banesco",
        value: "1",
    },
];
export var viewTypeAfyProps = {
    title: "Usuarios",
    titleColor: themeCore.colorsV2.primary,
    bgColorIconButton: "#EBEEF6",
    bgColorIconButtonSelected: "#1D34FE",
    colorIconButton: "#1D34FE",
    colorIconButtonSelected: "#fff",
    titleView: "Vista",
    floatRight: true,
    insurersView: [
        {
            id: "2",
            name: "List",
            active: false,
            icon: {
                icon: icons.TableRows,
            },
        },
        {
            id: "1",
            name: "GridView",
            active: true,
            icon: {
                icon: icons.GridView,
            },
        },
        {
            id: "3",
            name: "tableView",
            active: false,
            icon: {
                icon: icons.TableView,
            },
        },
    ],
};
export var paginationAFYProps = {
    showPagination: true,
    titlePagination: "Filas por página",
    countPagination: 125,
    rowsPerPage: 20,
    pagePagination: 1,
    rowsPerPageOption: [20, 25, 50],
    showFirstButton: true,
    showLastButton: true,
};
export var drawerProps = {
    openDrawer: false,
    view: 4,
    BgBackdrop: themeCore.colors.backgroundLoader,
    BgcCloseButton: themeCore.colors.background,
    colorIcon: themeCore.colors.lightBlue,
    bgColorDrawer: themeCore.colors.background,
    customHeight: "auto",
    img: logoAffinity,
    title: "Crear usuario",
    subTitle: "Crea un nuevo usuario para tu sistema",
    placeholder: "Nombre del usuario",
    titleButton: "Crear",
    onValueApply: function () { },
    onClose: function () { },
};
export var stepsProps = {
    steps: [
        {
            label: "",
            icon: _jsx(GridCheckCircleIcon, {}),
        },
    ],
    currentStep: 1,
};
export var searchFiltersBarProps = {
    showSearch: false,
    setShowSearch: function () { },
    SimpleItem: {
        id: "",
        name: "",
        value: "",
    },
    avatarConfig: {
        iconBgColor: themeCore.colorsV2.primary,
        iconAvatar: icons.Search,
        iconColor: "#fff",
        sizeIcon: sizesIcon.standard,
        avatarVariant: variantsAvatar.rounded,
    },
    buttonConfig: {
        titleInputCloseSearch: "Cerrar",
        titleClearButton: "Limpiar",
        titleSearchButton: "Buscar",
        disabledSearchButton: false,
    },
    inputSearchConfig: {
        placeholderTextSearch: "Buscar usuario",
        disabledSearchInput: false,
        onChangeTextSearch: function (e) {
            console.log("onChangeTextSearch", e.target.value);
        },
        onBlurTextSearch: function (e) {
            console.log("onBlurTextSearch");
        },
    },
    filters: [
        {
            id: "role",
            label: "Rol",
            list: [
                {
                    id: "1",
                    name: "Administrador",
                    value: "admin",
                    active: false,
                },
                {
                    id: "2",
                    name: "Agente",
                    value: "agent",
                    active: false,
                },
            ],
            defaultCheckedItems: [],
            onSelect: function () { },
        },
        {
            id: "sucursal",
            label: "Sucursal",
            list: [
                {
                    id: "1",
                    name: "Sucursal 1",
                    value: "sucursal1",
                    active: false,
                },
            ],
            defaultCheckedItems: [],
            onSelect: function () { },
        },
    ],
};
export var userCardAddNewProps = {
    backgroundColor: "#fff",
    icon: icons.AddCircle,
    height: "113px",
    iconColor: themeCore.colorsV2.primary,
    fontSizeIcon: "24px",
    heightList: 55,
    title: "Agregar",
    isList: false,
    onClickAdd: function () { },
};
export var cardContextMenuAFYProps = {
    backgroundColor: themeCore.colors.background,
    height: "113px",
    onClickContextMenu: function () { },
    textDetails: "Agregar",
    heightList: "55px",
    menuItem: [
        {
            disabled: false,
            icon: {
                color: "#006ac6",
                icon: icons.Edit,
                size: sizesIcon.standard,
            },
            id: "1",
            name: "Modificar",
        },
        {
            disabled: false,
            icon: {
                color: "#006ac6",
                icon: icons.DeleteForever,
                size: sizesIcon.standard,
            },
            id: "2",
            name: "Eliminar",
        },
        {
            disabled: false,
            icon: {
                color: "#006ac6",
                icon: icons.PersonAddDisabled,
                size: sizesIcon.standard,
            },
            id: "3",
            name: "Activo / Inactivo",
        },
        {
            disabled: false,
            icon: {
                color: "#006ac6",
                icon: icons.CheckBox,
                size: sizesIcon.standard,
            },
            id: "4",
            name: "Ver Roles",
        },
    ],
};
export var createUserProps = {
    formState: {
        firstName: "",
        lastName: "",
        birthDate: "",
        idType: "",
        idNumber: "",
        gender: "",
        username: "",
        email: "",
        password: "",
        confirmPassword: "",
        company: "",
        branch: "",
        intermediary: "",
    },
    onFormChange: function () { },
    onSubmit: function () { },
    idTypeOptions: [],
    genderOptions: [],
    companyOptions: [],
    branchOptions: [],
    intermediaryOptions: [],
};
export var drawerRolesListProps = {
    openDrawer: false,
    view: 4,
    BgBackdrop: themeCore.colors.backgroundLoader,
    BgcCloseButton: themeCore.colors.background,
    colorIcon: themeCore.colors.lightBlue,
    onValueApply: function () { },
    onClose: function () { },
    paginationProps: {
        count: 10,
        pagePagination: 1,
        rowsPerPages: 10,
        onChangePage: function () { },
        onChangeRowsPerPage: function () { },
        rowsPerPageOptions: [5, 10, 25],
    },
    onClickEdit: function () { },
    data: [],
    columns: [],
};
export var drawerRolesEditProps = {
    open: false,
    onClose: function () { },
    availableItems: [],
    assignedItems: [],
    onSave: function () { },
    title: "Asignar Permisos",
    subtitle: "Asigna los permisos que deseas asignar al usuario",
    availableTitle: "Permisos Disponibles",
    assignedTitle: "Permisos Asignados",
    availablePlaceholder: "Buscar",
    assignedPlaceholder: "Buscar",
    availableSearch: "",
    assignedSearch: "",
    onAvailableSearchChange: function () { },
    onAssignedSearchChange: function () { },
    filteredAvailable: [],
    filteredAssigned: [],
};
